import { Award, Users, Hammer, Heart } from "lucide-react";

const AboutSection = () => {
  const stats = [
    { icon: Award, value: "5+", label: "Années d'expérience" },
    { icon: Users, value: "100+", label: "Clients satisfaits" },
    { icon: Hammer, value: "100+", label: "Projets réalisés" },
    { icon: Heart, value: "100%", label: "Passion artisanale" },
  ];

  return (
    <section
      id="apropos"
      className="py-20 md:py-32 bg-warm-cream relative"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_ttwood-villard/artifacts/ap2kw6um_Messenger_creation_E3F62496-6F95-4125-A1C1-0AEBD7A2B084.jpg"
                alt="Coffret en bois artisanal réalisé par TT Wood - ébéniste Villard-Bonnot"
                loading="lazy"
                decoding="async"
                className="w-full h-[500px] object-cover"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-xl p-6 hidden md:block">
              <p className="font-handwritten text-3xl text-deep-oak">
                Fait avec passion
              </p>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="text-forest-green font-medium text-sm uppercase tracking-wider">
              À propos de nous
            </span>
            <h2 
              className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-deep-oak mt-3 mb-6"
              data-testid="about-title"
            >
              L'Art du Bois,
              <br />
              Transmis avec Passion
            </h2>
            <p className="text-text-secondary text-base md:text-lg leading-relaxed mb-6">
              Depuis plus de 5 ans, TTWood perpétue l'excellence de l'artisanat 
              menuisier au cœur de l'Isère. Installé à Villard-Bonnot, notre atelier 
              est le lieu où traditions ancestrales et techniques modernes se 
              conjuguent pour créer des pièces d'exception.
            </p>
            <p className="text-text-secondary text-base md:text-lg leading-relaxed mb-8">
              Chaque projet est une histoire unique. Nous travaillons main dans 
              la main avec nos clients pour transformer leurs idées en réalités 
              tangibles, alliant esthétique, fonctionnalité et durabilité.
            </p>

            {/* Values */}
            <div className="grid grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-forest-green/10 flex items-center justify-center flex-shrink-0">
                  <Hammer className="w-5 h-5 text-forest-green" />
                </div>
                <div>
                  <h4 className="font-medium text-deep-oak">Savoir-faire</h4>
                  <p className="text-sm text-text-muted">Techniques traditionnelles</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-forest-green/10 flex items-center justify-center flex-shrink-0">
                  <Heart className="w-5 h-5 text-forest-green" />
                </div>
                <div>
                  <h4 className="font-medium text-deep-oak">Passion</h4>
                  <p className="text-sm text-text-muted">Amour du métier</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-20">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 text-center shadow-sm border border-gray-100 card-hover"
              data-testid={`stat-${index}`}
            >
              <stat.icon className="w-8 h-8 text-forest-green mx-auto mb-3" />
              <p className="font-heading text-3xl md:text-4xl font-bold text-deep-oak">
                {stat.value}
              </p>
              <p className="text-text-muted text-sm mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
